export enum ObjectModelActionType {
  DefaultAction = 1,
  FillForm = 2,
  ChangeFieldValues = 3,
  CustomNotification = 4,
  ViewDocument = 5,
  RunProcess = 6,
  LinkToAccount = 7,
}

export const ObjectModelActionDefaultLabels = {
  [ObjectModelActionType.CustomNotification]: 'Send Notification',
};